import { useState, useRef, useEffect } from 'react'
import { Splitter, SplitterPanel } from 'primereact/splitter'
import { Dialog } from 'primereact/dialog'
import DocumentView from './DocumentView'


const DocumentsSplitView = (props) => {
    const normalizeToList = (docs) => Array.isArray(docs) ? docs : (docs ? [docs] : [])
    const doc1List = normalizeToList(props.doc1)
    const doc2List = normalizeToList(props.doc2)

    const [selectedDoc1, setSelectedDoc1] = useState(doc1List[0])
    const [selectedDoc2, setSelectedDoc2] = useState(doc2List[0])

    const tabScrollRef = useRef(null)

    const scrollTabs = (direction) => {
        const scrollAmount = 150
        if (tabScrollRef.current) {
            tabScrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            })
        }
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!props.visible || doc2List.length <= 1) return
            const currentIndex = doc2List.indexOf(selectedDoc2)
            if (e.key === 'ArrowRight' && currentIndex < doc2List.length - 1) {
                setSelectedDoc2(doc2List[currentIndex + 1])
            } else if (e.key === 'ArrowLeft' && currentIndex > 0) {
                setSelectedDoc2(doc2List[currentIndex - 1])
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [props.visible, selectedDoc2, doc2List])

    const renderDocument = (docURL) => {
        if (docURL) {
            return <DocumentView fileUrl={docURL} showZoomControl={true} />
        }
        return <p className="p-4 text-center">No document available</p>
    }

    const renderFloatingTabs = (docs, selectedDoc, setSelectedDoc, side = 'left') => {
        if (docs.length <= 1) {
            return null
        }

        const isRight = side === 'right'
        const leftPosition = isRight ? 'calc(50% + 1rem)' : '1rem'

        return (
            <div className={`floating-tab-panel ${doc1List.length > 1 || doc2List.length > 1 ? 'mt-4' : ''}`}
                style={{ left: leftPosition }}
            >
                <span style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }} onClick={() => scrollTabs('left')}>◀</span>
                <div ref={tabScrollRef} style={{ display: 'flex', gap: '1rem', overflowX: 'auto', flex: 1, scrollbarWidth: 'none' }}>
                    {docs.map((docUrl, index) => (
                        <span
                            key={index}
                            onClick={() => setSelectedDoc(docUrl)}
                            className="cursor-pointer"
                            style={{
                                whiteSpace: 'nowrap',
                                fontWeight: selectedDoc === docUrl ? 'bold' : 'normal',
                                color: selectedDoc === docUrl ? 'teal' : '#666',
                                borderBottom: selectedDoc === docUrl ? '2px solid teal' : '2px solid transparent',
                                paddingBottom: '3px'
                            }}
                        >
                            {`Document ${index + 1}`}
                        </span>
                    ))}
                </div>
                <span style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }} onClick={() => scrollTabs('right')}>▶</span>
            </div>
        )
    }

    return (
        <Dialog header={props.header} visible={props.visible} className="documents-split-view" style={{ width: '90vw', height: '85vh', position: 'relative' }} onHide={props.onHide}>
            {renderFloatingTabs(doc1List, selectedDoc1, setSelectedDoc1, 'left')}
            {renderFloatingTabs(doc2List, selectedDoc2, setSelectedDoc2, 'right')}

            <div style={{ height: 'calc(100vh - 100px)' }} className={`${(doc1List.length > 1 || doc2List.length > 1) ? 'mt-5' : ''}`}>
                <Splitter style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                    <SplitterPanel style={{ width: '50%', height: (doc1List.length > 1 || doc2List.length > 1) ? '85%' : '88%', overflow: 'hidden' }}>
                        {renderDocument(selectedDoc1)}
                    </SplitterPanel>
                    <SplitterPanel style={{ width: '50%', height: (doc1List.length > 1 || doc2List.length > 1) ? '85%' : '88%', overflow: 'hidden' }}>
                        {renderDocument(selectedDoc2)}
                    </SplitterPanel>
                </Splitter>
                <style>
                    {` .p-splitter-gutter { display: none !important; } `}
                </style>
            </div>
        </Dialog>
    )
}

export default DocumentsSplitView